export default {
  "hero.eyebrow": "Centro de recursos de la hoja USFans",
  "hero.title": "Hoja USFans — recursos, guías y herramientas actualizados",
  "hero.subtitle": "Encuentra recursos de la hoja USFans, guías de compra, información de vendedores, consejos de envío y control de calidad, guías de almacén, reseñas e información de seguridad — todo organizado en un centro de recursos fácil de usar.",
  "hero.ctaPrimary": "Hoja USFans",
  "hero.ctaSecondary": "Comprar ahora",
  "hero.ctaGuide": "Ver la guía",
  "hero.trust": "Recursos actualizados · Guías prácticas · Información de seguridad · Recurso independiente",

  "categories.title": "Comprar por categoría",
  "categories.subtitle": "Ve directo a tu categoría favorita en el sitio principal.",
  "categories.dropdownLabel": "Explorar categorías",
  "categories.dropdownPlaceholder": "Selecciona una categoría…",

  "featured.title": "La hoja USFans, explicada",
  "featured.body": "La hoja USFans reúne categorías de productos populares, enlaces actualizados e información útil de compra en una sola vista organizada. Ya sea que busques zapatillas, camisetas deportivas o compares opciones de envío, la hoja te ayuda a pasar rápidamente de la investigación a la página correcta — con enlaces que te llevan directo al sitio principal.",

  "article.title": "Últimas guías y recursos",
  "article.subtitle": "Guías originales y detalladas para ayudarte a aprovechar al máximo la hoja USFans.",
  "article.cardTitle": "Guía completa de la hoja USFans 2026",
  "article.excerpt": "Aprende qué es la hoja USFans, cómo usarla, qué categorías explorar y los conceptos básicos de seguridad y envío que debes conocer antes de comprar.",
  "article.readMore": "Leer la guía completa",

  "why.title": "Por qué existe este recurso",
  "why.body": "Encontrar información fiable y actualizada sobre la hoja USFans puede llevar mucho tiempo. Este centro de recursos independiente organiza lo esencial — categorías, guías y consejos de seguridad — para que puedas tomar decisiones informadas sin buscar en páginas dispersas.",

  "cta.title": "¿Buscas los últimos recursos de USFans?",
  "cta.body": "Explora el sitio principal para obtener más información, enlaces actualizados y promociones vigentes.",
  "cta.button": "Visitar el sitio principal",
};